import MyAccount from '../MyAccount/MyAccount'

const Account = () => {
  return <MyAccount />
}

export default Account